<template>
  <v-container fluid>
     <v-dialog
persistent
      v-model="dialog2"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card>
        <v-card-title class="text-h5 primary">
          <v-btn
            icon
            dark
            @click="dialog2 = false"
          >
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>  Service {{ service.company_name }}
        </v-card-title>
        <v-card-text class="pt-4">
          <ServiceTransport :transport="service">
          </ServiceTransport>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog2 = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-data-table
      :headers="transportHeaders"
      :items="transports"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      :search="search"
      item-key="id_transport"
      show-expand
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Transport Data</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            solo
            dense
            append-icon="mdi-magnify"
            label="Search Transport Data"
            class="mr-3 white"
            outlined
            hide-details
          ></v-text-field>
          <v-dialog
            v-model="dialog"
            persistent
            width="800"

          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="primary"
                v-bind="attrs"
                v-on="on"
              >
                Add New Transport  <v-icon>{{ icons.mdiPlus }}</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="">
                <span class="text-h6 ">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col md="6">
                    <v-text-field
                      v-model="form.company_name"
                      dense
                      outlined
                      placeholder="Company Name"
                      label="Company Name"
                    />
                    <v-autocomplete
                      v-model="form.depot_location"
                      :items="regions"
                      item-text="region_name"
                      item-value="id_region"
                      dense
                      outlined
                      placeholder="Depot Location"
                      label="Depot Location"
                    />
                    <v-text-field
                      v-model="form.phone"
                      type="number"
                      dense
                      outlined
                      placeholder="Phone"
                      label="Phone"
                    />
                    <v-text-field
                      v-model="form.email"
                      dense
                      outlined
                      placeholder="Email"
                      label="Email"
                    />

                    <v-dialog
                      ref="dialog"
                      v-model="modal"
                      :return-value.sync="form.contract_valid_start"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="form.contract_valid_start"
                          placeholder="Contract Valid Start"
                          label="Contract Valid Start "
                          ::prepend-icon="icons.mdiCalender"
                          dense
                          outlined
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="form.contract_valid_start"
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="CekDialog()"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.dialog.save(form.contract_valid_start)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-dialog>
                    <v-dialog
                      ref="dialog3"
                      v-model="modal5"
                      :return-value.sync="form.contract_valid_end"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="form.contract_valid_end"
                          placeholder="Contract Valid End "
                          label="Contract Valid End"
                          ::prepend-icon="icons.mdiCalender"
                          dense
                          outlined
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="form.contract_valid_end"
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="modal5 = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.dialog3.save(form.contract_valid_end)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-dialog>
                    <v-textarea
                      v-model="form.note"
                      label="Note"
                      placeholder="Note"
                      outlined
                      dense
                    ></v-textarea>
                  </v-col>
                  <v-col md="6">
                    <v-text-field
                      v-model="form.contact_person_name"
                      dense
                      outlined
                      placeholder="Contact Person Name"
                      label="Contact Person Name"
                    />
                    <v-text-field
                      v-model="form.contact_person_phone"
                      type="number"
                      dense
                      outlined
                      placeholder="Contact Person Phone"
                      label="Contact Person Phone"
                    />
                    <v-text-field
                      v-model="form.contact_person_email"
                      dense
                      outlined
                      placeholder="Contact Person Email"
                      label="Contact Person Email"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  class="text-capitalize"
                  text
                  @click="CekDialog()"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  class="text-capitalize"
                  text
                  @click="Save"
                >
                  {{ TittleButton }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-row>
            <v-col
              cols="12"
              md="5"
            >
              <v-simple-table>
                <tbody>
                  <tr>
                    <td>Contact Person</td>
                    <td>: {{ item.contact_person_name }}</td>
                  </tr>
                  <tr>
                    <td>Contact Person Phone</td>
                    <td>: {{ item.contact_person_phone }}</td>
                  </tr>
                  <tr>
                    <td>Contact Person Email</td>
                    <td>: {{ item.contact_person_email }}</td>
                  </tr>
                  <tr>
                    <td>Contract Valid Start</td>
                    <td
                      colspan="2"
                      rowspan="1"
                    >
                      : {{ item.start }}
                    </td>
                  </tr>
                  <tr>
                    <td>Contract Valid End</td>
                    <td colspan="2">
                      : {{ item.end }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
            <v-col>
              <v-simple-table>
                <tbody>
                  <tr>
                    <td>Notes</td>
                    <td colspan="2">
                      : {{ item.note }}
                    </td>
                  </tr>
                  <tr>
                    <td>Email</td>
                    <td colspan="2">
                      : {{ item.email }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </td>
      </template>
      <template #[`item.contract`]="{ item }">
        <v-chip
          :color="getColor(item.contract_valid_end,item.contract_valid_start)"
          dark
          v-text="CountContract(item.contract_valid_end,item.contract_valid_start)"
        >
        </v-chip>
      </template>
      <template #[`item.actions`]="{ item }">
        <v-btn
          small
          class="mr-2 text-capitalize primary"
          @click="editItem(item)"
        >
          <v-icon>{{ icons.mdiPencil }}</v-icon>
        </v-btn>
        <v-btn
          small
          class="mr-2 text-capitalize primary"
          @click="deleteItem(item)"
        >
          <v-icon>{{ icons.mdiTrashCan }}</v-icon>
        </v-btn>
        <v-btn

          right
          class="primary text-capitalize"
          small
          @click="OpenService(item)"
        >
          Service <v-icon>{{ icons.mdiPlus }}</v-icon>
        </v-btn>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Reset
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import axios from 'axios'
import {
  mdiPencil,
  mdiTrashCan,
  mdiPlus,
  mdiClose,
  mdiCalendar,
} from '@mdi/js'
import ServiceTransport from '@/layouts/components/all-data/service-transport.vue'

export default {
  components: { ServiceTransport },

  data() {
    return {
      icons: {
        mdiPencil,
        mdiTrashCan,
        mdiPlus,
        mdiClose,
        mdiCalendar,
      },
      modal: false,
      modal5: false,
      expanded: [],
      singleExpand: true,
      dialog: false,
      dialog2: false,
      editedIndex: -1,
      search: '',
      form: {
        id_transport: '',
        company_name: '',
        depot_location: '',
        phone: '',
        email: '',
        contact_person_name: '',
        contact_person_phone: '',
        contact_person_email: '',
        contract_valid_start: '2022-01-01',
        contract_valid_end: '2022-01-01',
        note: '',
      },
      service: [],
      transportHeaders: [
        { text: 'Company Name', value: 'company_name' },
        { text: 'Depot Location', value: 'depot_name' },
        { text: 'Phone', value: 'phone' },
        { text: 'Contract', value: 'contract' },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
          width: 300,
        },
      ],
      transports: [],
      regions: [],
      datenow: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Add New Transport' : 'Edit Transport'
    },
    TittleButton() {
      return this.editedIndex === -1 ? 'Save Transport' : 'Update Transport'
    },
  },

  mounted() {
    this.initialize()
    this.initializeregion()
  },
  methods: {
    initializeregion() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.get('auth/Region').then(response => {
        this.regions = response.data.data
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    getColor(end, start) {
      if (this.datenow < start) {
        return 'warning'
      } if (this.datenow > end) {
        return 'error'
      }

      return 'primary'
    },
    CountContract(end, start) {
      if (this.datenow < start) {
        return 'Valid Soon'
      } if (this.datenow > end) {
        return 'Expired'
      }

      return 'Valid'
    },
    CekDialog() {
      this.form = {
        id_transport: '',
        company_name: '',
        depot_location: '',
        phone: '',
        email: '',
        contact_person_name: '',
        contact_person_phone: '',
        contact_person_email: '',
        contract_valid_start: '2022-01-01',
        contract_valid_end: '2022-01-01',
        note: '',
      }
      this.dialog = false
      this.editedIndex = -1
    },
    OpenService(item) {
      this.service = item
      this.dialog2 = true
    },
    editItem(item) {
      this.editedIndex = this.transports.indexOf(item)
      this.form = item
      this.dialog = true
    },
    deleteItem(item) {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/DeleteTransport', item).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    initialize() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.get('auth/Transport').then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.transports = response.data.data
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    Save() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/SaveTransport', this.form).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
        this.dialog = false
        this.CekDialog()
        this.editedIndex = -1
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
  },
}
</script>
